import {
    LOAD_SMS_ALERTS_FAIL,
    LOAD_SMS_ALERTS_REQUEST,
    LOAD_SMS_ALERTS_SUCCESS,
    TOGGLE_SMS_ALERTS_SUCCESS,
} from './actions';
import api from '@/redux/api/alerts';
import { createSelector } from 'reselect';
import { getAuthToken } from './user';
import { getDeployment } from './config';
import { GlobalState } from '../rootReducer';

// reducer
const DEFAULT_STATE = {
    subscriptions: [],
};

export type State = typeof DEFAULT_STATE;

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case LOAD_SMS_ALERTS_SUCCESS:
            return {
                ...state,
                subscriptions: action.payload,
            };
        case TOGGLE_SMS_ALERTS_SUCCESS:
            return {
                ...state,
                subscribed: action.payload.subscribed,
            };
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.smsAlerts;
// @ts-ignore - ignoring "state"
const idSelector = (state: GlobalState, id: number) => id;

export const getSubscriptions = createSelector(stateSelector, (state) => state.subscriptions || []);
export const getSubscriptionIdList = createSelector(getSubscriptions, (subscriptions) => {
    const subs = subscriptions.map((subscription) => subscription.alertTypeId) || [];

    // @ts-ignore
    return [...new Set(subs)];
});
export const getSubscriptionsById: (state: any, selector: any) => any = createSelector(
    [getSubscriptions, idSelector],
    (subscriptions, id) => {
        return subscriptions.filter((subscription) => subscription.alertTypeId === id);
    }
);

export const getSubscribedToSMSAlerts = createSelector(stateSelector, (state) =>
    Boolean(state.subscriptions.find((alert) => Boolean(alert.subscribed) && alert.deliveryType === 's'))
);

export const getSubscribedToBrowserAlerts = createSelector(stateSelector, (state) =>
    Boolean(state.subscriptions.find((alert) => Boolean(alert.subscribed) && alert.deliveryType === 'b'))
);

const shouldFetchSmsAlerts = createSelector(stateSelector, () => true);

/* ACTION CREATORS */
const loadSmsAlerts = () => async (dispatch, getState) => {
    try {
        const state = getState();
        const deployment = getDeployment(state);
        const authToken = getAuthToken(state);

        dispatch({
            type: LOAD_SMS_ALERTS_REQUEST,
        });
        const response = await api.fetchSmsAlerts({ authToken, deployment });
        return dispatch({
            meta: { actionTime: Date.now() },
            payload: response.payload,
            type: LOAD_SMS_ALERTS_SUCCESS,
        });
    } catch (error) {
        return dispatch({
            error: true,
            payload: error,
            type: LOAD_SMS_ALERTS_FAIL,
        });
    }
};

export const toggleSmsAlerts = (alertTypeId: number, deliveryType: string, subscribed: boolean) => async (
    dispatch,
    getState
) => {
    try {
        const state = getState();
        const deployment = getDeployment(state);
        const authToken = getAuthToken(state);

        dispatch({
            type: LOAD_SMS_ALERTS_REQUEST,
        });
        const response = await api.toggleSmsAlerts({ alertTypeId, authToken, deliveryType, deployment, subscribed });
        return dispatch({
            meta: { actionTime: Date.now() },
            payload: response.payload,
            type: LOAD_SMS_ALERTS_SUCCESS,
        });
    } catch (error) {
        return dispatch({
            error: true,
            payload: error,
            type: LOAD_SMS_ALERTS_FAIL,
        });
    }
};

export const fetchSmsAlertsIfNeeded = () => async (dispatch: Function, getState: Function) => {
    if (shouldFetchSmsAlerts(getState())) {
        return dispatch(loadSmsAlerts());
    }
    return Promise.resolve();
};
